<template>
  <div class="relative group">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5 text-[#1c4848]/40 absolute left-3.5 top-3 group-focus-within:text-[#1c4848] pointer-events-none"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
    <input
      :value="modelValue"
      type="text"
      :placeholder="placeholder"
      class="w-full bg-white border border-[#1c4848]/10 rounded-xl px-4 py-2.5 text-xs font-medium focus:outline-none focus:border-[#1c4848]/30 focus:ring-2 focus:ring-[#1c4848]/5 transition-all pl-10"
      @input="$emit('update:modelValue', ($event.target).value)"
    >
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: 'Search pages...' }
});
defineEmits(['update:modelValue']);
</script>
